import React, { useEffect, useState } from "react";
import { adminAuth, adminAxios } from "@/lib/adminAuth";
import { Loader2, CheckCircle, XCircle } from "lucide-react";

const AdminSettingsPage = () => {
  const user = adminAuth.getUser();
  const [backendOk, setBackendOk] = useState(null);

  useEffect(() => {
    adminAxios()
      .get("/health")
      .then(() => setBackendOk(true))
      .catch(() => setBackendOk(false));
  }, []);

  const Card = ({ title, children }) => (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
      <p className="font-semibold text-slate-900">{title}</p>
      {children}
    </div>
  );

  return (
    <div className="space-y-5 max-w-xl">
      <Card title="Compte">
        <div>
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-0.5">Email administrateur</p>
          <p className="text-sm text-slate-900">{user?.email}</p>
        </div>
        <div>
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-0.5">Rôle</p>
          <p className="text-sm text-slate-900 capitalize">{user?.role || "admin"}</p>
        </div>
      </Card>

      <Card title="Système">
        <div className="flex items-center gap-2">
          {backendOk === null && <Loader2 className="h-4 w-4 animate-spin text-slate-400" />}
          {backendOk === true && <CheckCircle className="h-4 w-4 text-emerald-500" />}
          {backendOk === false && <XCircle className="h-4 w-4 text-red-500" />}
          <p className="text-sm text-slate-700">
            Backend : {backendOk === null ? "Vérification…" : backendOk ? "En ligne" : "Hors ligne"}
          </p>
        </div>
      </Card>
    </div>
  );
};

export default AdminSettingsPage;
